<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter13">
<h1><a id="page_31"></a><a href="#/003toc#ch13">Creamy Loaded Baked-Potato Soup</a></h1>
<p class="noindent">Whenever I order baked-potato soup in a restaurant, I am invariably disappointed. Usually it tastes of flour and has no real flavor—just a bland soup base mixed with some sorry potatoes. This smooth soup is made flavorful by cooking the potatoes in chicken broth, then embellishing it with green onions, bacon, and sharp Cheddar. This soup is a whole meal and can be the centerpiece for a casual weekend dinner with friends. Make sure to serve extra cheese, bacon, onions, and sour cream on the side.</p>
<p class="noindent">4 tablespoons (½ stick) unsalted butter</p>
<p class="noindent">2 medium leeks, finely chopped, using the white and some of the tender green parts</p>
<p class="noindent">4 large russet potatoes, peeled and cut into ½-inch dice (see savvy)</p>
<p class="noindent">4 cups chicken broth</p>
<p class="noindent">1 cup whole milk</p>
<p class="noindent">2 cups finely shredded sharp Cheddar cheese</p>
<p class="noindent">6 green onions, finely chopped, using the white and some of the tender green parts</p>
<p class="noindent">8 strips bacon, cooked crisp, drained, and crumbled</p>
<p class="noindent">Salt and freshly ground black pepper</p>
<p class="noindent">1 cup sour cream for garnishing</p>
<p class="noindent">heat the butter in a large skillet over medium-high heat. Add the leeks and sauté until softened, 2 to 3 minutes. Transfer the leeks to the insert of a 5- to 7-quart slow cooker and add the potatoes and broth. Cover the slow cooker and cook on high for 3 hours or on low for 5 to 6 hours, until the potatoes are tender. Using an immersion blender, purée the soup, or cool the soup and purée it in a blender.</p>
<p class="noindent">reduce the heat to low and add the milk, cheese, green onions, and bacon. Cover the slow cooker and cook for an additional 1 hour. Season with salt and pepper.</p>
<p class="noindent">serve the soup garnished with a dollop of sour cream.</p>
<p class="noindent">serves 8–10</p>
<hr/>
<p class="sidebar_head"><img alt="image 1" class="inline" src="images/image-01.jpg"/> potato savvy</p>
<p class="noindent">I use russet (baking) potatoes because they will be puréed at the end of the cooking time, giving a rich creamy texture to the soup. If you prefer a chunky soup, use 6 medium red or Yukon gold potatoes.</p>
<p class="noindent"><strong>cooking savvy</strong></p>
<p class="noindent">Always cool mixtures before puréeing in a food processor or blender, so that if they erupt all over you, you won’t get burned.</p>
<p class="noindent"><strong>serving savvy</strong></p>
<p class="noindent">Serving soup in hollowed-out bread bowls is a nice way to serve a crowd. Cut the top off a bread round and hollow out the inside, using a serrated knife, leaving about ¾-inch all the way around the inside. I usually brush the inside with butter or olive oil and bake the bread at 350°F for about 10 minutes. This helps to crisp up the bread.</p>
</div>
<p class="breakhere"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 019-chapter13.vue?dd00592c